import clsx from 'clsx';
import { Button } from '@/components/button';
import { Modal, ModalBody, ModalButtonContainer } from '@/components/modal/modal';
import { SuccessCircleSvg } from '@/components/svgs/success-circle';
import { useBranding } from '@/outlets/branding-outlet';
import { formatPrice } from '@/util/formats';
import styles from './encounter-created-modal.module.css';
import { useTranslation } from '@/contexts/i18n-context';

const translationBase = 'visit.preScreenQuestions';

interface EncounterCreatedModalProps {
  encounterId: number;
  price: number;
  onClose: () => void;
}

export function EncounterCreatedModal({ encounterId, price, onClose }: EncounterCreatedModalProps) {
  const { t } = useTranslation();
  const { promoCodeEnabled } = useBranding();

  return (
    <Modal isOpen onClose={onClose} hideCloseButton>
      <SuccessCircleSvg className={styles.successCircle} />
      <h2 className="h4">{t(`${translationBase}.modal.title`)}</h2>
      <ModalBody>{t(`${translationBase}.modal.text`)}</ModalBody>
      <ModalButtonContainer className={styles.buttonContainer}>
        <div className={styles.infoContainer}>
          <span className={styles.visitPrice}>
            {t(`${translationBase}.modal.price`, {
              visitPrice: (
                <span key="price-value" className={clsx('body-1', styles.price)}>
                  {formatPrice(price)}
                </span>
              ),
            })}
          </span>
          {promoCodeEnabled && (
            <span className={clsx('body-4', styles.subText)}>
              {t(`${translationBase}.modal.subText`)}
            </span>
          )}
        </div>
        <Button as="a" to={`/visit/${encounterId}/questions`}>
          {t(`${translationBase}.modal.continueButton`)}
        </Button>
      </ModalButtonContainer>
    </Modal>
  );
}
